<div id="product" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg" fxLayout="row" fxLayoutAlign="space-between center">

      <!-- APP TITLE -->
      <div fxLayout="row" fxLayoutAlign="start center">

        <button class="mr-0 mr-sm-16" mat-icon-button [routerLink]="'/pages/canton'">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <div class="product-image mr-8 mr-sm-16" *fuseIfOnDom
          [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
          @if (canton && img) {
            <img [src]="getImage(img)">
          }
          @if (!canton || !canton.flag) {
            <img [src]="'assets/images/district.svg'">
          }
        </div>

        <div fxLayout="column" fxLayoutAlign="start start"
          *fuseIfOnDom [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
          @if (canton) {
            <div class="h2">
              {{canton.name}}
            </div>
          }
          <div class="subtitle secondary-text">
            <span>{{'canton.canton_detail' | translate}}</span>
          </div>
        </div>
      </div>
      <!-- / APP TITLE -->


      <div>
        <button mat-raised-button
          class="save-product-button mat-white-bg mt-16 mt-sm-0"
          (click)="updateCanton(true)">
          <span>{{'main.update' | translate}}</span>
        </button>

        <button mat-raised-button
          class="save-product-button mat-white-bg mt-16 mt-sm-0"
          (click)="deleteCanton()">
          <span>{{'main.delete' | translate}}</span>
        </button>
      </div>

    </div>
    <!-- / HEADER -->

    <div class="content-card mat-white-bg">

      <!-- CONTENT -->
      <div class="content">
        <div class="content-block">

          <cropper [avatar]="logo" [page]="'canton-detail'" (sendImg)="setImg($event)"></cropper>
        </div>
        <div class="content-block">
          <form [formGroup]="formGroup" class="canton-form">
            <mat-form-field class="width-100">
              <mat-label>{{ 'canton.name' | translate }}</mat-label>
              <input formControlName="name" matInput required>
            </mat-form-field>
            <mat-form-field class="width-50">
              <mat-label>{{ 'canton.code' | translate }}</mat-label>
              <input formControlName="code" matInput required>
            </mat-form-field>
            <mat-form-field appearance="fill" class="width-50">
              <mat-label>{{ 'canton.country' | translate }}</mat-label>
              <mat-select formControlName="countryId" required>
                @for (country of countries; track country.id) {
                  <mat-option [value]="country.id">
                    {{country.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" class="width-100">
              <mat-label>{{ 'organization.welcomeText' | translate }}</mat-label>
              <textarea matInput cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="2"
              cdkAutosizeMaxRows="5" formControlName="welcomeText"></textarea>
            </mat-form-field>
          </form>
        </div>

      </div>
      <!-- / CONTENT -->

    </div>

  </div>
  <!-- / CENTER -->
</div>


